import { connect } from 'react-redux';
import {
  CarouselProduct,
  CarouselProductClickPayload,
  CarouselProductVisiblePayload,
  ProductCarousel,
  ProductCarouselProps,
} from '@noths/polaris-client-ribbons-design-system';
import { Dispatch } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  recommendedProductsShelfProductClick,
  recommendedProductsShelfVisible,
} from '../modules/actions';

const mapStateToProps = (
  { product, richRelevance }: ReduxApplicationState,
  props: ProductCarouselProps,
) => ({
  products: richRelevance[props.placementType].products as CarouselProduct[],
  placementTitle: richRelevance[props.placementType].placementTitle,
  currency: product.price.currency,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onComponentVisible: (payload: CarouselProductVisiblePayload) =>
    dispatch(recommendedProductsShelfVisible(payload)),
  onProductClick: (payload: CarouselProductClickPayload) =>
    dispatch(recommendedProductsShelfProductClick(payload)),
});

export const RecommendedProductsShelfContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductCarousel);
